<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <rating-department-index></rating-department-index>
        </v-layout>
    </v-container>
</template>
<script>
    import RatingDepartmentIndex from "../../components/ratingAdmin/RatingDepartmentStat/RatingDepartmentIndex";

    export default  {
        components: {
            RatingDepartmentIndex,
        }
    }
</script>